import React, { Component } from 'react';
import Helmet from 'react-helmet';

import IPageMeta from '@interfaces/page-meta';
import Settings from '@interfaces/settings';
import cutTags from 'client/helpers/cutTags';

export interface StateProps {
    settings: Settings;
}

export interface DispatchProps {
    setPageMeta(data: IPageMeta): void;
}

type Props = IPageMeta & StateProps & DispatchProps;

class PageMeta extends Component<Props> {
    public componentDidMount() {
        // Переносим мету-информацию в стор, что бы прокидывать ее в шаринги
        this.props.setPageMeta(this.prepareData());
    }

    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { title, description } = this.props;
        const { cutTitle, cutDescription, image } = this.prepareData();

        return (
            <Helmet>
                <title>{title}</title>
                <meta property="og:title" content={cutTitle} />
                <meta property="twitter:title" content={title} />
                {Boolean(description) && <meta name="description" content={description} />}
                {Boolean(cutDescription) && <meta property="og:description" content={cutDescription} />}
                {Boolean(cutDescription) && <meta property="twitter:description" content={cutDescription} />}
                {Boolean(image) && <meta property="og:image" content={image} />}
            </Helmet>
        );
    }

    private prepareData() {
        const { title, description, image, settings } = this.props;
        const fullTitle = !title ? settings.title : `${title} - ${settings.title}`;

        return {
            cutTitle: cutTags(fullTitle),
            cutDescription: cutTags(description).substr(0, 250),
            image
        };
    }
}

export default PageMeta;
